(() => {
  const faqSelector = '.gs-faq-section';

  const initialiseFaqSection = (section) => {
    if (!section || section.dataset.gsFaqInitialised === 'true') return;

    section.dataset.gsFaqInitialised = 'true';
    section.classList.add('gs-faq-ready');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px',
    });

    observer.observe(section);
  };

  const initialiseFaqSections = (root = document) => {
    if (root.matches?.(faqSelector)) initialiseFaqSection(root);
    root.querySelectorAll?.(faqSelector).forEach(initialiseFaqSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseFaqSections(), { once: true });
  } else {
    initialiseFaqSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseFaqSections(event.target);
  });
})();
